import { Component } from 'react';
import styles from './ErrorBoundary.module.css';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  /** Name shown in the error message e.g. "Employees" */
  section?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div className={styles.wrapper}>
          <i className={`fa-solid fa-triangle-exclamation ${styles.icon}`} aria-hidden="true" />
          <p className={styles.title}>
            {this.props.section
              ? `Could not load ${this.props.section}`
              : 'Something went wrong'}
          </p>
          <p className={styles.message}>{this.state.error?.message}</p>
          <button className={styles.retry} onClick={this.reset}>
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
